export default function (props: any) {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
            <path
                d="M5.25051 8.15276L15.5633 3.96104C16.079 3.75146 16.6665 4.00323 16.8704 4.52114L18.3 8.15276M8.84949 12.4433H11.5505M8.84949 15.1866H15.1505M21 10.896V9.15276C21 8.60047 20.5523 8.15276 20 8.15276H4C3.44772 8.15276 3 8.60047 3 9.15276V10.896C4.34949 10.896 5.7 11.8101 5.7 13.6393C5.7 15.4684 4.35051 16.3825 3 16.3825V18.1258C3 18.6781 3.44772 19.1258 4 19.1258H20C20.5523 19.1258 21 18.6781 21 18.1258V16.3825C19.6505 16.3825 18.3 15.0104 18.3 13.4102C18.3 11.8101 19.6505 10.896 21 10.896Z"
                stroke="#FFB82F"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
}
